'use client'

import { useSession } from '@marketplace-web/shared/session-data'
import { CurrencyAmountModel } from '@marketplace-web/currency/currency-data'

import ServiceFeeIncludedTitle from '../ServiceFeeIncludedTitle'

type Props = {
  thumbnailUrl?: string | null
  itemTitle: string
  transactionId: number
  itemsCount: number
  itemId: number
  serviceFee: CurrencyAmountModel
  totalAmountWithoutTax: CurrencyAmountModel
  itemPrice: CurrencyAmountModel
  sellerId?: number
  isSellerBusiness: boolean
}

const HeroMessagePriceBreakdown = ({
  thumbnailUrl,
  itemTitle,
  transactionId,
  itemsCount,
  itemId,
  totalAmountWithoutTax,
  serviceFee,
  itemPrice,
  sellerId,
  isSellerBusiness,
}: Props) => {
  const currentUserId = useSession().user?.id
  const isViewingOwnItem = sellerId === currentUserId

  return (
    <ServiceFeeIncludedTitle
      itemId={itemId}
      itemPrice={itemPrice}
      serviceFee={serviceFee}
      isSellerBusiness={isSellerBusiness}
      isItemOwner={isViewingOwnItem}
      itemPhotoSrc={thumbnailUrl}
      itemTitle={itemTitle}
      transactionId={transactionId}
      itemsCount={itemsCount}
      totalItemPrice={totalAmountWithoutTax}
    />
  )
}

export default HeroMessagePriceBreakdown
